import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button';

export type FooterIconProps = {
  /**
   * Passing href parameter for the url
   */
  href: string;
  /**
   * Expects any of the icon components from design-system.lib
   */
  icon: JSX.Element;
  /**
   * Title for the icon
   */
  title: string;
  /**
   * Additional unique id for FooterIcon component
   */
  id: string;
  /**
   * Handles the onClick functionality
   */
  onClick?: (id: string) => void;
  /**
   * The `rel` attribute defines the relationship between a linked resource and the current document.
   * Please see [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/rel) for the list of supported values.
   */
  rel?: HTMLAnchorElement['rel'];
};

export const FooterIcon = ({
  href,
  icon,
  id,
  title,
  onClick,
  rel,
}: FooterIconProps): JSX.Element => (
  <Button
    id={`footer-${id}`}
    as="a"
    href={href}
    title={title}
    color="tertiary"
    size="small"
    icon={icon}
    onClick={onClick ? (): void => onClick(id) : undefined}
    target="_blank"
    rel={rel}
  />
);

FooterIcon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rel: PropTypes.string,
};
